// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wqBD","title":"styles_title__JTVLc"};